import Alpine from 'alpinejs';

import './components/swiper';
import './components/video';
import './components/menu';
import './components/shopfilters';
import './components/subscriptions';
import './components/sample-packs';

// Import any custom Alpine components.
import share from './components/share';

// Register any custom Alpine components.
Alpine.data('share', share);

window.Alpine = Alpine;
Alpine.start();
